// Importing React/Redux/Third party Library components
import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { connect } from 'react-redux'

const StyledDiv = styled('div')`
  font-size: 11px;
  font-style: italic;
  padding-bottom: 26px;
  @media only screen and (min-width: 768px) {
    font-size: 12px;
  }
`
// Functional Component: Sepa Disclaimer Text
const SepaDisclaimerText = ({
  companyName,
  fromPayment,
  isLeaseAndRentWordReplaced,
}) => {
  const leaseReplacedText = isLeaseAndRentWordReplaced
    ? 'housing agreement'
    : 'lease'
  return fromPayment ? (
    <StyledDiv>
      {__(
        'By clicking save, I authorize {%s, 0} to store the above-specified payment method. When making a payment using this method, I agree to the terms and conditions and applicable convenience fees. For refund policies, please refer to your {%s, 1}.',
        [companyName, leaseReplacedText],
      )}
    </StyledDiv>
  ) : (
    <StyledDiv>
      {__(
        'By signing this mandate form, you authorise (A) {%s, 0} to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with the instructions from {%s, 0}. As part of your rights,  you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited. Please complete all the fields marked. Your rights are explained in a statement that you can obtain from your bank.',
        [companyName],
      )}
    </StyledDiv>
  )
}

// Default Props for Sepa Disclaimer Text Component
SepaDisclaimerText.defaultProps = {
  companyName: 'your property',
}

// Prop Types for Sepa Disclaimer Text Component
SepaDisclaimerText.propTypes = {
  companyName: PropTypes.string,
  fromPayment: PropTypes.bool,
  isLeaseAndRentWordReplaced: PropTypes.bool,
}

export default connect(({ productPermissions, propertyAssociation }) => {
  return {
    isLeaseAndRentWordReplaced:
      productPermissions?.replace_lease_and_rent ||
      propertyAssociation?.resident_portal?.replace_lease_and_rent ||
      false,
  }
})(SepaDisclaimerText)
